// extracted by mini-css-extract-plugin
module.exports = {"footerWrapper":"Footer_footerWrapper__tYN0Y","text":"Footer_text__1NaOG","icons":"Footer_icons__xYpN5","icon":"Footer_icon__1HZM_"};